// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__XQGzu","choiceBoxes":"toolbarselects_choiceBoxes__3ypWq","simpleField":"toolbarselects_simpleField__3RHdQ"};